import { Message } from 'element-ui';
import router from './router';
import store from '@/store';

router.beforeEach(async (to, from, next) => {
    // 白名单，所有在数组中的路径都可以直接放行
    // const whiteArr = ['/login','/ossauth','/tokenLogin','/share/live/:id']; // 开发使用login

    // if (whiteArr.includes(to.path)) {
    //     next();
    //     return;
    // }
    // 白名单正则数组
const whiteArr = [
  /^\/login$/,               // 严格匹配
  /^\/ossauth$/,             // 严格匹配
  /^\/tokenLogin$/,          // 严格匹配
  /^\/share\/live\/[^/]+$/   // 动态匹配 /share/live/:id
];

if (whiteArr.some(reg => reg.test(to.path))) {
  next();
  return;
}
    if (store.state.userInfo.token) {
        if (to.path.includes('login')) {
            next('/');
        }
        if (!store.state.userInfo.userInfo?.user?.userId) {
            await store.dispatch('getUserInfo');
        }
        next();
    } else {
        // if (to.path === '/admin/login') {
        //     Message.error('会话已过期，请重新登录');
        //     next();
        // }
        // next('/admin/login');
        Message.error('会话已过期，请重新登录');
        setTimeout(() => {
            if(process&&process.env&&process.env.NODE_ENV === 'development'){
                window.location.href = '/login';
            }else{
                // window.location.href = '/admin/login';
                window.location.href = process.env.VUE_APP_ADMIN_CONTEXT_PATH + '/login';
            }
           
        }, 1000);
    }
});
